
        <div class="row-sm text-center" *ngIf="(this.auth.loggedIn$ |async) as login">
            <img alt="Panini's logo" *ngIf="!login.logged" src="../../../assets/imgs/Panini.png" />
        </div>
        <div class="row">
            <div class="col text-center" *ngIf="(this.auth.loggedIn$ |async) as login">
                <div *ngIf="!login.logged" class="homeContainer">
                    <ng-container  *ngIf="(this.auth.screenLoad$ |async) as screen">
                        <div class="loading" *ngIf="screen.nameScreen ==''">
                            <div *ngIf="this.lang">
                                <span [innerHTML]="('label.loadingUserInfo' | translation)">....</span>
                            </div>
                            <app-spinner></app-spinner>
                        </div>
                        <div *ngIf="screen.nameScreen !=''" id="registrationLoginContainer" appSpy>
                            <ng-container *ngIf="(this.tutorService.tutorWithoutChilds$ |async) as isChildsArrayEmpty">
                                <div class="d-flex justify-content-center h-100" *ngIf="isChildsArrayEmpty">
                                    <span class="fw-bold align-self-center" [innerHTML]="('label.tutorwithoutchilds' | translation)">...</span>
                                </div>
                            </ng-container> 
                        </div>
                    </ng-container >
                </div>
                <div *ngIf="login.logged">
                    <app-minors-profile [lang]="this.lang ??'en'" [tutorUID]="login.userLogged.UID ??''" (deleteMinor)="deleteMinor($event)" [respMinors]="this.listMinors" [minors]="minorInfo" *ngIf="isMinorsProfile"></app-minors-profile>
                    <app-tutor-profile [lang]="this.lang ??'en'" *ngIf="isTutorProfile"></app-tutor-profile>
                </div>
            </div>
        </div>
